document.addEventListener("DOMContentLoaded", function () {
  window.dataLayer = window.dataLayer || [];

  function sendPageViewEvent() {
    if (!window.GTMData) {
      console.warn("GTMData non definito");
      return;
    }

    window.dataLayer.push({
      event: "viewpage",
      page_path: window.location.pathname,
      full_url: window.location.origin + window.location.pathname,
      login_status: window.GTMData.login_status,
      user_id: window.GTMData.user_id,
      is_logged_user: window.GTMData.is_logged_user,
      //store_country: window.GTMData.store_country.toLowerCase(),
      //store_language: window.GTMData.store_language,
      hashed_email: window.GTMData.hashed_email,
    });

    console.log("✅ Evento 'viewpage' inviato", window.dataLayer);
  }

  sendPageViewEvent();

  document.addEventListener("shopify:section:load", sendPageViewEvent);
  document.addEventListener("shopify:page:load", sendPageViewEvent);
  window.addEventListener("popstate", sendPageViewEvent);
});
